// import hooks
import { useState } from "react";
export const useSearchSelected = () => {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    return {
        selectedIndex,
        setSelectedIndex,
        resetSelectedHandler: () => {
            setSelectedIndex(-1);
        },
    };
};
export default useSearchSelected;
